import request from '@/utils/http'
import { PFX, SRM } from '../../constant/constant.js'

// 下发整改任务
export const assignImprovementTask = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/assignImprovementTask`,
        method: 'post',
        data,
    })
}

// 流程信息查询
export const getMipAuditDetail = data => {
    return request({
        url: `${SRM}/supplierMipAudit/detail`,
        method: 'post',
        data,
    })
}

// 流程信息审批
export const approvalMipAudit = data => {
    return request({
        url: `${SRM}/supplierMipAudit/approval`,
        method: 'post',
        data,
    })
}

// 下载整改模版
export const downloadRegisterGuide = params => {
    return request({
        url: `${PFX}/public/supplier/supplierInfo/downloadRegisterGuide`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'application/json' },
    })
}

// 上传整改附件-提交审批
export const submitImprovement = data => {
    return request({
        url: `${SRM}/supplierWarehousePerformance/submitImprovement`,
        method: 'post',
        data,
    })
}
